module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image9-53e1b81d4a471e0c0b7a89472410eb6a.jpg";